export enum billType {
    NonBillable = 'Non-Billable',
    Billable = 'Billable',
    PTO = 'PTO',
    Holiday = 'Holiday',
    Bereavement = 'Bereavement',
}
